import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonsModule, IconModule, LoadingModule } from 'axis-components';
import { Logger } from '../_core/logger.service';
import { NotificationService } from '../_services/notification/notification.service';
import { PdfService } from '../_services/pdf/pdf.service';
import { RequestService } from '../_services/request/request.service';
import { FormType } from '../config/constants';

@Component({
   standalone: true,
  selector: 'app-completed-request',
  templateUrl: './completed-request.component.html',
  styleUrl: './completed-request.component.scss',
  imports: [ButtonsModule, IconModule, RouterModule, CommonModule, LoadingModule],
})
export class CompletedRequestComponent {

  isInsured = false;
  isBroker = false;

  insuredContent = '';
 brokerContent = '';

  showPIP = false;
  showUMUIM = false;

  downloadPIPInProgress = false;
  downloadUMUIMInProgress = false;

  constructor(private requestService: RequestService, private pdfService: PdfService, 
    private notificationService: NotificationService) {
    const role = this.requestService.getUserRole();
    this.isInsured = role === 'insured';
    this.isBroker = role === 'broker';
    const formTypeList = this.requestService.requestFormTypeList;

    for (const formType of formTypeList) {
        if (formType.toLowerCase() === 'pip') {
          this.showPIP = true;
        }
        if (formType.toLowerCase() === 'um_uim') {
          this.showUMUIM = true;
        }
      } 

      if (this.showUMUIM && this.showPIP) {
        this.insuredContent = 'The Underinsured/Uninsured Motorist Coverage Forms and Personal Injury Protection forms were all completed and available by clicking download documents below.';
        this.brokerContent = 'The Underinsured/Uninsured Motorist Coverage Forms and Personal Injury Protection forms for this account were already completed and signed by the Insured. You can download them below.';
        return;
      }
      
      if (this.showUMUIM) {
        this.insuredContent = 'Your Underinsured/Uninsured Motorist Coverage Forms are completed and available by clicking download documents below.';
        this.brokerContent = 'The Underinsured/Uninsured Motorist Coverage Forms for this account were already completed and signed by the Insured. You can download them below.';
        return;
      }

      if (this.showPIP) {
        this.insuredContent = 'Your Personal Injury Protection forms are completed and available by clicking download documents below.';
        this.brokerContent = 'The Personal Injury Protection forms for this account were already completed and signed by the Insured. You can download them below.';
        return;
      }

  }

  downloadPIPDocuments() {
    Logger.log('getPIPPdfFromGDMS');
     let insuredKey = this.requestService.request.insuredKey;
      if (!insuredKey || insuredKey.length === 0) {
        return;
      }
    this.downloadPIPInProgress = true;
    this._downloadDocuments(FormType.PIP);
  }

  downloadUMUIMDocuments() {
     let insuredKey = this.requestService.request.insuredKey;
      if (!insuredKey || insuredKey.length === 0) {
        return;
      }
    Logger.log('getUMUIMPdfFromGDMS');
     this.downloadUMUIMInProgress = true;
    this._downloadDocuments(FormType.UM_UIM);
  }

  _downloadDocuments(formType: FormType) {
   let insuredKey = this.requestService.request.insuredKey;
   if (!insuredKey || insuredKey.length === 0) {
    return;
   }
   
    this.pdfService.getPdfFromGDMS(formType, insuredKey).subscribe({
                next: (response) => {
                  if (formType === FormType.PIP) {
                    this.downloadPIPInProgress = false;
                  } else if (formType === FormType.UM_UIM) {
                    this.downloadUMUIMInProgress = false;
                  }
                  this.handlePdfResponse(formType, response);                                 
                },
                error: (err) => {
                  this.downloadUMUIMInProgress = false;
                  console.error('Error generating PDF:', err);
                  this.notificationService.showNotification(
                    'The forms you are trying to download are currently unavailable. Please try again later.',
                    'error',
                  );
                },
              });
  }

  handlePdfResponse(formType, response: any) {
      Logger.log('handlePdfResponse');
      const blob = new Blob([response], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          // To download:
          const a = document.createElement('a');
          a.href = url;
          if (formType === FormType.PIP) {
            a.download = 'PIP Documents.pdf';
          } else if (formType === FormType.UM_UIM) {
            a.download = 'UM/UIM Documents.pdf';
          }
          a.click();
          window.URL.revokeObjectURL(url);
    }

  
}
